import React, { useState } from "react";
import PropTypes from 'prop-types';
import { useDetectClickOutside } from "react-detect-click-outside";
import "../../features.common.styles.scss";

const Pagination = (props) => {
  const { totalPages, onPageChange } = props;

  const [state, setState] = useState({
    page: 0,
    show: false,
  });

  const ref = useDetectClickOutside({
    onTriggered: () =>
      setState({
        ...state,
        show: false,
      }),
  });
  return (
    <div className="filternav toolnav">
      <div className="pagecount">
        <label>Go to page</label>
        <a
          className="pagelink firstpage"
          onClick={() => {
            setState((state) => ({
              ...state,
              page: 0,
            }));
            onPageChange(0);
          }}
        >
          First
        </a>
        <div className="frmgroup">

          <div className="dropdown bootstrap-select" ref={ref}>
            <button
              type="button"
              tabIndex="-1"
              className="btn dropdown-toggle bs-placeholder btn-light"
              data-bs-toggle="dropdown"
              onClick={() => setState({ ...state, show: !state.show })}
            >
              <div className="filter-option">
                <div className="filter-option-inner">
                  <div className="filter-option-inner-inner">
                    {state.page + 1}
                  </div>
                </div>
              </div>
            </button>
            <div
              className={`dropdown-menu ${
                state.show ? "show pagination_place" : ""
              }`}
            >
              <div className="inner show" tabIndex={-1}>
                <ul className="dropdown-menu inner show ">
                  {Array.from(Array(totalPages).keys()).map((m, index) => (
                    <li className="selected" key={ index }>
                      <a
                        className={
                          state.page === index
                            ? "dropdown-item active selected"
                            : "dropdown-item"
                        }
                        tabIndex="0"
                        onClick={() => {
                          setState({
                            ...state,
                            page: index,
                            show: !state.show,
                          });
                          onPageChange(index);
                        }}
                      >
                        <span className="text">{index + 1}</span>
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
        <a
          className="pagelink lastpage"
          onClick={() => {
            setState((state) => ({
              ...state,
              page: totalPages - 1,
            }));
            onPageChange(totalPages - 1);
          }}
        >
          Last
        </a>
      </div>
    </div>
  );
};

Pagination.propTypes = {
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;



